import { render, staticRenderFns } from "./AboutCopia.vue?vue&type=template&id=242ebda3"
import script from "./AboutCopia.vue?vue&type=script&lang=js"
export * from "./AboutCopia.vue?vue&type=script&lang=js"
import style0 from "./AboutCopia.vue?vue&type=style&index=0&id=242ebda3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports